// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-collections-structure-delete-collections-workbooks-dialog-content__header {
  font-weight: 500;
}
.dl-collections-structure-delete-collections-workbooks-dialog-content__list {
  padding: 10px 0;
}
.dl-collections-structure-delete-collections-workbooks-dialog-content__title {
  margin-bottom: 8px;
  margin-left: 8px;
}
.dl-collections-structure-delete-collections-workbooks-dialog-content__item {
  display: flex;
}
.dl-collections-structure-delete-collections-workbooks-dialog-content__icon {
  min-width: 20px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/CollectionsStructure/DeleteCollectionsWorkbooksContent/DeleteCollectionsWorkbooksContent.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AAGI;EACI,eAAA;AADR;AAII;EACI,kBAAA;EACA,gBAAA;AAFR;AAKI;EACI,aAAA;AAHR;AAMI;EACI,eAAA;AAJR","sourcesContent":[".dl-collections-structure-delete-collections-workbooks-dialog-content__header {\n  font-weight: 500;\n}\n.dl-collections-structure-delete-collections-workbooks-dialog-content__list {\n  padding: 10px 0;\n}\n.dl-collections-structure-delete-collections-workbooks-dialog-content__title {\n  margin-bottom: 8px;\n  margin-left: 8px;\n}\n.dl-collections-structure-delete-collections-workbooks-dialog-content__item {\n  display: flex;\n}\n.dl-collections-structure-delete-collections-workbooks-dialog-content__icon {\n  min-width: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
